import GetAdProductsError from './GetAdProductsError.js'
import GetPaymentAdProductsError from './GetPaymentAdProductsError.js'
import GetVisibilityProductsError from './GetVisibilityProductsError.js'
import InvalidProductError from './InvalidProductError.js'

export default class ProductsErrorsFactory {
  static getVisibilityProductsError = () => new GetVisibilityProductsError()

  static getPaymentAdProductsError = () => new GetPaymentAdProductsError()

  static getAdProductsError = () => new GetAdProductsError()

  static invalidProductError = () => new InvalidProductError()
}
